import React, { Component } from 'react';

import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import './PagarDespesa.css';
import Utils from '../../js/utils';

import {
    Row,
    Col,
    Spin,
    Select,
    Form,
    Checkbox,
    Button,
    Modal,
} from 'antd';

const FormItem = Form.Item;
const Option = Select.Option;

class PagarDespesa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listaTipoBaixaTituloAPagar: [],
            loading: false,
            buscando: false,
            modalVisible: false
        }                

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
        this.utils = new Utils();
    }

    componentWillMount() {
        this.getListaTipoBaixaTituloAPagar();
    }

    componentDidUpdate(){
        if(this.state.modalVisible != this.props.modalVisible){
            this.props.form.resetFields();
            this.setState({modalVisible: this.props.modalVisible});
        }
    }

    getListaTipoBaixaTituloAPagar = ()=>{        

        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.dadosProvider.getDadosUsuario().Cripto
        };

        this.setState({ buscando: true });

        this.dataService.GetListaTipoBaixaTituloAPagar(dados, (retorno) => {
            if (retorno.length > 0) {
                this.setState({ buscando: false });
                this.setState({ listaTipoBaixaTituloAPagar: retorno});

                console.log(retorno);
            }

        }, (erro) => {
            console.error(erro);
            this.setState({ buscando: false });
        });
    }

    baixarTituloAPagar = ()=>{   
        this.props.form.validateFields((err, values) => {
            if (!err) {
                var dados = {
                    "cdTipoBaixaTituloAPagar": values.cdTipoBaixaTituloAPagar,
                    "cdTitulo": this.props.cdTitulo,
                    "uiFilial": this.dadosProvider.getUiFilial(),
                    "cripto": this.dadosProvider.getDadosUsuario().Cripto
                }
        
                this.setState({ loading: true });
        
                this.dataService.BaixarTituloAPagar(dados, (retorno) => {
        
                    this.setState({ loading: false });
        
                    if (retorno.Status === "1") {
                        Modal.success({
                            title: 'Sucesso',
                            content:(<div dangerouslySetInnerHTML={{ __html: this.utils.HtmlDecode(retorno.Msg)}}/>)                    
                        });

                        this.props.onClose(true);
                    }else {
                        Modal.error({
                            title: 'Erro',
                            content:(<div dangerouslySetInnerHTML={{ __html: this.utils.HtmlDecode(retorno.Msg) }} />)
                        });
                    }
                }, (erro) => {
                    console.error(erro);
                    this.setState({ loading: false });
                });
            }
        });
    }

    handleCancelDespesa = (e) => {        
        this.props.onClose();
    }

    render(){
        const { getFieldDecorator } = this.props.form;
        return(
            <Modal
                title="Pagar Despesa"
                visible={this.state.modalVisible}
                onCancel={this.handleCancelDespesa}
                footer={null}>
                {this.state.buscando ?
                    (<Row>
                        <Col className="imageRadio">
                            <div className="divSpin">
                                <Spin className="imageSpin" />
                            </div>
                        </Col>
                    </Row>) 
                    :                 
                (
                    <div>
                        <Form name="formPagarDespesa" className="formPagarDespesa">
                            <Row>
                                <FormItem
                                    label="Como deseja efetuar o pagamento?">
                                    {getFieldDecorator('cdTipoBaixaTituloAPagar', {
                                        rules: [{
                                            required: true, message: 'Selecione uma forma de pagamento',
                                        }]
                                    })(
                                        <Select>
                                            {this.state.listaTipoBaixaTituloAPagar.map((item, index) => <Option key={item["CdTipoBaixaTituloAPagar"]}>{item["DsTipoBaixaTituloAPagar"]}</Option>)}
                                        </Select>
                                    )}                            
                                </FormItem>
                            </Row>
                        </Form>      
                        <Row className="buttonRow" gutter={16}>
                            <Col sm={{ span: 24 }}>
                                <Button size="large" type="primary" loading={this.state.loading} onClick={this.baixarTituloAPagar}>Pagar</Button>
                            </Col>
                        </Row>
                    </div>  
                )}
            </Modal>
        )
    }
}

export default Form.create()(PagarDespesa);


// WEBPACK FOOTER //
// ./src/Components/PagarDespesa/PagarDespesa.js